import styled from 'styled-components';

export const GasDetailGraphContainer = styled.div`
  height: 77vh;
  margin-top: 20px;
  padding: 1rem;
  background: #262f3b;
  border-radius: 10px;
  overflow-y: scroll;
  overflow-x: hidden;
`